import { Modal, Button } from '@vzmi/shp_shared_compo'
import { unbindBeforeunload } from '../../../../Common/BeforeUnload'

const reloadUpdateListingModelPage = id => {
  // proposal form 有設定 post form 如果要離開會有確認視窗，
  // 這裡是使用者確認後會導走不必要再跳提示干擾流程
  unbindBeforeunload()
  window.location.href = `/proposal/updateListingModel?listingId=${id}`
}

const ModalFooter = props => (
  <Button
    onClick={() => reloadUpdateListingModelPage(props.id)}
    data-role='modal-confirm'
    size='large'
  >
    確定
  </Button>
)

const ListingChangedModal = props => {
  const {
    id,
    ...restProps
  } = props
  return (
    <Modal
      className='listing-changed-modal'
      closable={false}
      footer={<ModalFooter id={id} />}
      {...restProps}
    >
      <br />
      賣場屬性項目在編輯過程中已有異動，請重新調整後再次送出。
    </Modal>
  )
}

export default ListingChangedModal
